import type { AlertValues } from 'views/Alerts/models/alert';

const STORAGE_KEY = 'wt_alerts';

export const loadAlerts = (): AlertValues[] | null => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return null;
    return parsed as AlertValues[];
  } catch {
    return null;
  }
};

export const saveAlerts = (alerts: AlertValues[]): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(alerts));
};
